var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 26"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#f9f9f9",
  d: "M0 0h30v26H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.9 21.4 17.7 1.7c-1.2-2.1-4.2-2.1-5.4 0L1.2 21.4C0 23.5 1.5 26 3.8 26h22.4c2.4 0 3.9-2.5 2.7-4.6M15 7.8v8.9M15 19.9v1.9"
}))));
export default SvgWarning;